import { Transforms } from "slate";
export var insertImage = function (editor, url) {
    var text = { text: "" };
    var image = { type: "image", url: url, children: [text] };
    Transforms.insertNodes(editor, image);
    Transforms.insertNodes(editor, {
        type: "paragraph",
        children: [{ text: "" }],
    });
};
